import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '../../Api/ChessRestClient';

export interface SyncStudiesProgressData {
  total_studies?: number;
  imported_studies?: number;
  failed_studies?: string[];
}

export interface SyncStudiesProgressResponse {
  status: 'IN_PROGRESS' | 'COMPLETED';
  data?: SyncStudiesProgressData;
}

export default function useSyncStudiesProgress(
  handleOnSuccess?: (data: SyncStudiesProgressResponse) => void,
  handleOnError?: (error: any) => void,
) {
  return useMutation<SyncStudiesProgressResponse, Error, void>(
    async () => {
      const response = await ChessRestClient.get(
        '/learning/study_games/get_pull_studies_status/',
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      // Previously the error callback was only invoked from onSuccess when no
      // success handler was passed, so a failed poll request (network blip,
      // 5xx) silently stopped the polling loop with the UI stuck on
      // "Syncing…" forever.
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );
}
